import { create } from 'zustand'

interface ReportSelectedTask {
    selectedTasks: { id: string; _version: number }[]
    isAllTasksSelected: boolean
    setSelectedTasks: (task: { id: string; _version: number }) => void
    setIsAllTasksSelected: (isSelected: boolean, tasks: { id: string; _version: number }[]) => void
}

const useReportSelectedTask = create<ReportSelectedTask>((set, get) => ({
    selectedTasks: [],
    isAllTasksSelected: false,
    setSelectedTasks: task =>
        set({
            selectedTasks: get().selectedTasks.find(t => t.id === task.id)
                ? get().selectedTasks.filter(t => t.id !== task.id)
                : [...get().selectedTasks, task],
        }),
    setIsAllTasksSelected: (isSelected, tasks) => set({ isAllTasksSelected: isSelected, selectedTasks: tasks }),
}))

export default useReportSelectedTask
